import cookies from 'js-cookie';

const SATU_COOKIE_NAME = '_satu';

const INSERT_API_ENDPOINT = process.env.APP_ENV === 'production'
  ? 'https://stats.setapp.com/insert'
  : 'https://stats.setapp.macpaw.dev/insert';

class AnalyticsClient {
  getSatuId() {
    return cookies.get(SATU_COOKIE_NAME) ?? null;
  }

  trackEvent(eventData) {
    window.dataLayer.push({
      ...eventData,
      event: 'setapp',
    });
  }

  trackPageView(title, url) {
    window.dataLayer.push({
      event: 'virtualPageView',
      page: {
        title,
        url,
      },
    });
  }

  async insertDatahubData(tableName, data) {
    const payload = {
      _table: tableName,
      _data: data,
    };

    const response = await fetch(INSERT_API_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error('Insert to Datahub request failed', response.status);
    }
  }
}

export default AnalyticsClient;
